import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../provider/AppContext";
import { useNavigate } from "react-router-dom";
import styles from "./Footer.module.css";

const Footer = ({
  nextPageLink,
  nextPageText = "next",
  backPageLink,
  backPageText = "back",
  setShowPlanner = false,
}) => {
  const { appData, setAppData } = useContext(AppContext);
  const navigator = useNavigate();
  const [currentPage, setCurrentPage] = useState(0); // Track the current page
  const pageDict = {
    0: "/colorSelection",
    1: "/template",
    2: "/font",
  };
  return (
    <>
      <div
        className={`container-fluid d-flex justify-content-between ${styles["botton-holder-container"]}`}
      >
        <a
          onClick={() => navigator(`/${appData.backPageLink}`)}
          style={{ width: "100px", textAlign: "left" }}
        >
          {(appData.backPageText !== "" ? "< " : "") + appData.backPageText}
        </a>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "10px",
          }}
        >
          {[0, 1, 2].map((index) => (
            <div
              key={index}
              style={{
                width: "10px",
                height: "10px",
                borderRadius: "50%",
                backgroundColor:
                  index === appData.currentPage ? "#007bff" : "#ccc", // Highlight current page with blue
                margin: "0 5px",
                cursor: "pointer",
                transition: "background-color 0.3s",
              }}
              onClick={() => {
                setCurrentPage(index);
                navigator(pageDict[index]); // Change to clicked page
              }} // Change to clicked page
            />
          ))}
        </div>
        <a
          onClick={() => {
            if (appData.nextPageLink === "complete") {
              setShowPlanner(true);
              setAppData({ ...appData, showPlanner: true });
            } else {
              navigator(`/${appData.nextPageLink}`);
            }
          }}
          style={{ width: "100px", textAlign: "right" }}
        >
          {appData.nextPageText + (appData.nextPageText !== "" ? " >" : "")}
        </a>
      </div>
    </>
  );
};
export default Footer;
